import { Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "../Reveal";
import LandingPhone from "./LandingPhone";

const bullets = [
  {
    t: "Trade on web today",
    d: "Spot and OTC — full platform in your browser, no install required.",
  },
  {
    t: "Take control of your wealth",
    d: "KYC, whitelisting, and security controls built for Indian compliance standards.",
  },
];

export default function FreeYourMoney() {
  return (
    <section className="cm-landing-section bg-white border-t border-[var(--cm-border)]" data-testid="free-your-money">
      <div className="cm-container grid lg:grid-cols-2 gap-16 items-center">
        <Reveal variant="fade-right" duration={1000} className="flex justify-center">
          <div className="relative w-full max-w-[520px]">
            <div
              className="absolute -inset-4 rounded-[28px] opacity-50 blur-2xl pointer-events-none"
              style={{
                background: "radial-gradient(circle, rgba(2,44,237,0.15) 0%, transparent 70%)",
              }}
            />
            <LandingPhone
              variant={0}
              alt="CoinMBX platform preview"
              className="relative w-full h-auto"
              testId="fym-phone"
            />
          </div>
        </Reveal>

        <div>
          <Reveal variant="fade-left">
            <div className="cm-landing-section-label mb-4">Web platform</div>
            <h2 className="cm-landing-section-title">
              Free your money &amp; invest with confidence
            </h2>
          </Reveal>
          <Reveal variant="fade-left" delay={120}>
            <p className="mt-5 text-cm-grey text-[15px] leading-[1.8] max-w-[500px]">
              CoinMBX gives you professional trading tools, INR-friendly flows, and institutional
              OTC — on web or via our Android app (download the APK from our site).
            </p>
          </Reveal>

          <div className="mt-10 space-y-8">
            {bullets.map((b, i) => (
              <Reveal
                key={b.t}
                variant="fade-left"
                delay={250 + i * 150}
                className="flex items-start gap-4"
              >
                <div className="shrink-0 w-8 h-8 rounded-full bg-cm-blue grid place-items-center mt-0.5">
                  <Check size={16} className="text-white" strokeWidth={3} />
                </div>
                <div>
                  <h4 className="text-[17px] font-bold text-cm-navy">{b.t}</h4>
                  <p className="mt-2 text-[14px] text-cm-grey leading-[1.7]">{b.d}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal variant="fade-up" delay={500} className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/register"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-cm-blue text-white font-bold text-[14px] hover:bg-cm-blue-deep transition"
              data-testid="fym-get-started"
            >
              Create free account
              <ArrowRight size={16} />
            </Link>
            <Link
              to="/download"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-cm-blue/20 text-cm-blue font-semibold text-[14px] hover:bg-cm-lavender/50 transition"
              data-testid="fym-download-app"
            >
              Download app
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
